/* tslint:disable */
/* eslint-disable */
export enum WorkUseremploymentTypeEnum {
  Festanstellung = 'Festanstellung',
  Temporar = 'Tempor\xE4r',
  Extern = 'Extern'
}
